import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-20 text-slate-800">
      <h1 className="text-4xl font-black mb-8 text-slate-900">Privacy Policy</h1>
      <p className="text-sm text-gray-500 mb-8">Last Updated: February 2026</p>
      
      <section className="mb-10">
        <h2 className="text-2xl font-bold mb-4">1. Information We Collect</h2>
        <p className="leading-relaxed mb-4">
          RetailMitra collects business information (shop name, inventory details) and contact 
          information (phone number) to provide our billing services.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="text-2xl font-bold mb-4">2. Data Usage</h2>
        <p className="leading-relaxed mb-4">
          Your data is used solely to generate reports, manage inventory, and provide 
          WhatsApp reminders as demonstrated in our features. We do not sell your 
          business data to third parties.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="text-2xl font-bold mb-4">3. Security</h2>
        <p className="leading-relaxed mb-4">
          We use industry-standard encryption to ensure your "Digital Dukaan" data remains 
          secure and private.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;